

import React from 'react';
import { Input } from 'antd';
import { FormRow } from './Form';
import { HelpText } from './typography';

export default({ value, onChange }) => (
  <div>
    <FormRow labelSpan={6} height={400} label="Terms" tall={1}>
      <Input.TextArea
        id="spottingGroupEditingId"
        value={value}
        onChange={onChange}
        style={({ width: '100%', height: '100%' })}
      />
    </FormRow>
    <HelpText>
      enter one keyword/phrase on each row
    </HelpText>
  </div>
);
